import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export type NumberCellProps = {
  value: number;
  rowId: string;
  onValueChange?: (rowId: string, value: number) => void;
  min?: number;
  step?: number;
} & Omit<
  React.ComponentProps<'input'>,
  'value' | 'onChange' | 'type' | 'min' | 'step'
>;

export function NumberCell({
  value: apiValue,
  rowId,
  onValueChange,
  min = 0,
  step = 1,
  className,
  ...inputProps
}: NumberCellProps) {
  const [localValue, setLocalValue] = useState(apiValue);

  useEffect(() => {
    setLocalValue(apiValue);
  }, [apiValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (raw === '') {
      setLocalValue(min);
      onValueChange?.(rowId, min);
      return;
    }
    const num = Number.parseInt(raw, 10);
    if (Number.isNaN(num) || num < min) {
      return;
    }
    setLocalValue(num);
    onValueChange?.(rowId, num);
  };

  return (
    <Input
      className={cn('h-8 w-20', className)}
      min={min}
      onChange={handleChange}
      step={step}
      type='number'
      value={localValue}
      {...inputProps}
    />
  );
}
